export default "__VITE_ASSET__Br6TllWM__"